import { FormCreator, FormCreatorProps, FormFieldDef } from "@/components/shared/form-creator";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { TaskWorkflowCategory } from "@/models/task-workflow.model";
import { zodResolver } from "@hookform/resolvers/zod";
import { Dispatch, SetStateAction, useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

interface AddTaskWorkflowCategoryModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onSubmit: (values: Partial<TaskWorkflowCategory>) => Promise<void>;
}

const formSchema = z.object({
  title: z.string().min(1, "Title is required"),
});

type FormValues = z.infer<typeof formSchema>;

export default function AddTaskWorkflowCategoryModal({ open, setOpen, onSubmit }: AddTaskWorkflowCategoryModalProps) {
  const [loading, setLoading] = useState(false);
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      title: "",
    },
  });

  const fields: FormFieldDef[] = [{ type: "text", name: "title", label: "Title", required: true }];

  const props: FormCreatorProps = {
    form,
    onSubmit: async (values: FormValues) => {
      setLoading(true);
      try {
        onSubmit(values);
        form.reset();
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    },
    formDefinition: fields,
    buttonText: loading ? "Creating..." : "Create Category",
    resetButtonText: "Reset",
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <form>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Add Task Workflow Category</DialogTitle>
          </DialogHeader>

          <FormCreator {...props} />
        </DialogContent>
      </form>
    </Dialog>
  );
}
